import { cx, api, rx } from "../../../../api";
import { ofType, combineEpics } from 'redux-observable';
import { switchMap, takeUntil, map as rxmap, filter } from 'rxjs/operators';
import { formatDateTime, getTimezoneString } from '../../../../misc/misc';
import { actions } from '../actions';
import { f, fc } from "../../../../../i18n";
import { errorMap } from "../../../actions";
import { getAssetType } from "../../../../misc/assetTypes";

const requestEpic = (action$) => {
	return action$.pipe(
		ofType(actions.deviceUsages.request.type),
		switchMap(action =>
			rx(api.reports.deviceUsages, action.parameters).pipe(
				rxmap(operation => actions.deviceUsages.success({ usages: operation.response() })),
				errorMap(actions.deviceUsages.fail),
				takeUntil(action$.pipe(ofType(actions.deviceUsages.cancel.type)))
			)
		)
	)
}

const startPrepareEpic = (action$) => {
	return action$.pipe(
		ofType(actions.deviceUsages.export.type),
		rxmap(action => actions.deviceUsages.exportProgress({ progress: 100 }))
	)
}

const exportCsvEpic = (action$, state$) => {
	return action$.pipe(
		ofType(actions.deviceUsages.exportProgress.type),
		filter(action => action.progress == 100),
		rxmap(action => {
			const state = state$.value.reports.deviceUsages;
			const isGroup = !!state.parameters.groupingId;
			const isAssetType = !!state.parameters.isAssetTypes;

			// report header
			var csv = '"'
				+ fc('report type')
				+ '","'
				+ fc('generated')
				+ '","'
				+ fc('timezone')
				+ '","'
				+ fc('since')
				+ '","'
				+ fc('until')
				+ '"\n';
			csv += '"' + fc('device usages') + '"';  // report type
			csv += ',"' + formatDateTime(cx.now()) + '"'; // generated at
			csv += ',"' + getTimezoneString() + '"'; // timezone at
			csv += ',"' + formatDateTime(state.parameters.timeRange.since) + '"';
			csv += ',"' + formatDateTime(state.parameters.timeRange.until) + '"';
			csv += "\n\n";

			// content header
			let contentHeader = '';

			// Add URI and device name columns
			contentHeader += '"' + f('URI') + '","' + fc('device name') + '"';

			// Add Group and Asset Type columns if needed
			if (isGroup) {
				contentHeader += ',"' + fc('group') + '"';
			}

			if (isAssetType) {
				contentHeader += ',"' + fc('asset type') + '"';
			}

			// Add remaining columns
			contentHeader += ',"'
				+ fc('days')
				+ '","'
				+ fc('trips')
				+ '","'
				+ fc('distance') + ', ' + f('units.km')
				+ '"';

			// Add empty columns to ensure we have 7 columns total
			const columnsAdded = 5 + (isGroup ? 1 : 0) + (isAssetType ? 1 : 0); // 5 base columns + optional columns
			const emptyColumnsNeeded = 7 - columnsAdded;
			for (let i = 0; i < emptyColumnsNeeded; i++) {
				contentHeader += ',""';
			}

			csv += contentHeader + '\n';

			// content
			state.list.forEach(usage => {
				const device = state$.value.devices.map[usage.uri];
				let row = '';

				// Add URI and device name
				row += '"' + device.uri + '"';
				row += ',"' + (device.denomination() || '-') + '"';

				// Add Group value if needed
				if (isGroup) {
					let group = '-';
					if (device.categoryIds) {
						const categoryMap = state$.value.categories.general.map;
						device.categoryIds.forEach(categoryId => {
							const category = categoryMap[categoryId];
							const comprisingIds = category?.comprisingIds;
							if (comprisingIds && state.parameters.groupingId && comprisingIds.includes(state.parameters.groupingId)) {
								group = category.name;
							}
						});
					}
					row += ',"' + group + '"';
				}

				// Add Asset Type value if needed
				if (isAssetType) {
					const assetType = getAssetType(device.categoryIds)?.getName() || '-';
					row += ',"' + assetType + '"';
				}

				// Add remaining values
				row += ',"' + usage.days + '"';
				row += ',"' + usage.trips + '"';
				row += ',"' + usage.distance + '"';

				// Add empty columns to ensure we have 7 columns total
				for (let i = 0; i < emptyColumnsNeeded; i++) {
					row += ',""';
				}

				csv += row + '\n';
			});
			return actions.deviceUsages.exportDone({ csv });
		}),
	)
}

const epic = combineEpics(requestEpic, startPrepareEpic, exportCsvEpic);

export { epic };
